import styled, { css } from 'styled-components';

import { themeSize, themeColor, whenThemePropEqualsTrue, themeZIndex } from '../../../theme/getters';
import { media } from '../../../theme/media';
import { Pill } from '../pill';
import { Label } from '../pill/pill.styles';
import { noTapSelection } from '../../../theme/mixins';

export const Container = styled.div`
  ${noTapSelection};
  position: relative;
  display: flex;
  background: ${themeColor('white')};
  width: 100%;
  border-bottom: 1px solid ${themeColor('middleGray')};
`;

const whenWithSubmitButton = whenThemePropEqualsTrue('withSubmitButton');

const getScrollableContainerWithSubmitButtonStyles = whenWithSubmitButton(
  () => css`
    width: calc(100% - 64px);
  `
);

const getInnerContainerWithSubmitButtonStyles = whenWithSubmitButton(
  () => css`
    &:after {
      right: 64px;
    }
  `
);

export const InnerContainer = styled.div`
  display: block;
  width: 100%;

  &:after {
    width: 32px;
    height: 100%;
    position: absolute;
    right: 0;
    top: 0;
    background: linear-gradient(270deg, ${themeColor('white')} 0%, ${themeColor('transparent')} 100%);
    content: '';
  }

  ${getInnerContainerWithSubmitButtonStyles};

  ${media.tablet`
    &:after {
      display: none;
    }
  `}
`;

export const ScrollableContainer = styled.div`
  position: relative;
  display: flex;
  overflow: auto;
  justify-content: flex-start;
  width: 100%;
  padding: 24px 0 24px 24px;

  ${getScrollableContainerWithSubmitButtonStyles};

  &:after {
    content: '';
    flex: 0 0 ${({ withSubmitButton }) => (withSubmitButton ? 8 : 24)}px;
  }

  ${media.tablet`
    &:after {
      content: none;
    }
  `};

  ${media.mobileBig`
    flex-direction: row;
  `}

  ${media.tablet`
    width: 100%;
    justify-content: center;
    margin-right: 0;
    padding: 16px ${themeSize('contentPadding')}px;
  `};
`;

const whenCustomLabel = whenThemePropEqualsTrue('customLabel');

const getCustomLabelStyles = whenCustomLabel(
  () => css`
    border-color: ${themeColor('middleGray')};
    background: ${themeColor('pinkWash')};
    color: ${themeColor('primary')};

    i {
      color: ${themeColor('primary')};
    }
  `
);

export const FilterButton = styled(Pill)`
  align-self: flex-start;
  max-width: 216px;
  flex: 1 1 128px;
  border-radius: 24px;
  margin-right: 4px;
  padding: 7px 16px;

  ${getCustomLabelStyles};

  ${media.tabletPortrait`
    margin-right: 16px;
  `}

  ${media.tablet`
    align-self: initial;
    padding: 12px 16px 12px 24px;
    margin-bottom: 0;
    justify-content: space-between;
    border: none;
  `};

  :last-of-type {
    margin-right: 0;
  }

  span {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;

    ${media.tablet`
      font-size: 14px;
      line-height: 20px;
    `};
  }
`;

export const IconWrapper = styled.div`
  margin-left: 16px;
`;

export const SubmitButton = styled(FilterButton)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 24px;
  z-index: ${themeZIndex('overContent')};
  height: 32px;
  padding: 9px;
  border-radius: 24px;

  ${Label} {
    display: none;
  }

  ${IconWrapper} {
    margin-left: 0;
  }

  ${media.tablet` 
    position: relative;
    transform: none;
    padding: 12px 24px;
    height: unset;
    position: unset;
    right: unset;
    
    ${IconWrapper} {
      margin-left: 20px;
    }
    
    ${Label} {
      display: block;
    }
 `};
`;
